import React, { useState } from "react";
import PayoutTiles from "../../components/Point/PayoutTiles";
import PayoutTable from "../../components/Point/PayoutTable";
import SubmitButton from "../../components/Common/buttons/SubmitButton";
import PayoutRequest from "../../components/Point/PayoutRequest";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { exportToCSV, exportToExcel } from "../../utils/tableExports";
import { useSelector } from "react-redux";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const PointHistory = () => {
  const { t } = useTranslation();
  const [showPayout, setShowPayout] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("point");

  const [itemsPerPage, setItemsPerPage] = useState(10);
 
  const [sortOptions, setSortOptions] = useState({
    sortBy: "",
    direction: "",
  });
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const currencySymbol = useSelector(
    (state) => state.user.selectedCurrency.symbolLeft
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );

  const handlePayout = () => {
    setShowPayout((prevShowPayout) => !prevShowPayout);
  };

  //--------------------------------- API --------------------------------
  // const payoutDetails = ApiHook.CallPayoutDetails(
  //   currentPage,
  //   itemsPerPage,
  //   activeTabValues.map(item => `"${item}"`),
  //   sortOptions.sortBy,
  //   sortOptions.direction,
  // );
  const requestDetails = ApiHook.CallGetPvHistory(
    currentPage,
    itemsPerPage,
    activeTab,
    dateRange?.startDate,
    dateRange?.endDate,
    sortOptions.sortBy,
    sortOptions.direction
  );
  const tiles = ApiHook.CallGetPvTiles();
  const { isLoading, mutate } = ApiHook.CallPvReport();
  const reportHeader = [
    t("Date"),
    t("username"),
    t("fromusername"),
    t("country"),
    t("personalPV"),
    t("activePv"),
    t("leaderPv"),
    t("guestPv"),
    t("nonManagerPv"),
    t("passPv"),
    t("totalPv"),
    t("newPv"),
  ];

  const onHandleExport = (type) => {
    let paylaod = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    };
    mutate(paylaod, {
      onSuccess: (res) => {
        if (res?.data?.status) {
          if (type == "excel") {
            exportToExcel(
              res?.data?.data?.data,
              reportHeader,
              type,
              currencySymbol,
              conversionFactor
            );
          }
          exportToCSV(
            res?.data?.data?.data,
            reportHeader,
            type,
            currencySymbol,
            conversionFactor
          );
        } else {
          // toast.error(t(res.data.description))
        }
      },
    });
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Daily KC points update
    </Tooltip>
  );  

  return (
    <>
      <div className="page_head_top">{t("Points")}{" "}
      <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    ><i class="fa fa-info-circle" aria-hidden="true"></i>
      </OverlayTrigger>
      </div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-md-4"></div>
          <div className="col-md-4 text-end ">
            <div className="dropdown btn-group top_right_pop_btn_position">
              {requestDetails?.data?.isUserPayoutEnabled && (
                <SubmitButton
                  isSubmitting=""
                  click={handlePayout}
                  text={"payoutRequest"}
                  className="top_righ_pop_btn"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <PayoutTiles
        percentage={tiles?.data?.tilePercentages}
        tiles={tiles?.data}
      />
      <PayoutTable
        data={requestDetails?.data}
        type={"point"}
        setActiveTab={setActiveTab}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        activeTab={activeTab}
        setSortOptions={setSortOptions}
        setDateRange={setDateRange}
        onHandleExport={onHandleExport}
      />
    </>
  );
};

export default PointHistory;
